export default "__VITE_ASSET__BrN7_YnB__"